import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import { Text } from 'react-native-paper'
import Layout from '../Layout'
import Spacer from '../../../ui/atoms/Spacer'
import OtpInput from '../../../ui/atoms/OtpInput'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Link } from '../../../ui/atoms/Link'
import SignInStore from '../stores/SignInStore'
import Title, { SubTitle } from '../Title'
import SubmitButton from '../SubmitButton'
import RootStore from '../../../store/RootStore'
import { observer, Observer } from 'mobx-react'
import BackButton from '../BackButton'
import { dispatcher, pathFactory, paths } from '../../links'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from '../ErrorMessage'
import useRecaptcha from '../useRecaptcha'
import { useResponsive } from '../../../utils/hooks'
import LocalStorage from '../../../store/LocalStorage'
import SignupStore from '../stores/SignupStore'

export default observer(({ navigation, dontNavigate, route, setGoToForm }) => {
  const [otp, setOtp] = useState('')
  const {
    login,
    errors,
    removeError,
    canAskOtp,
    isNewUser,
    newUserSignInVerify,
    codeVerifier,
  } = SignInStore
  const { isBusy } = RootStore
  const { sm } = useResponsive()
  const recaptcha = useRecaptcha('signin-verify')

  useEffect(() => {
    RootStore.initRouteParams(route?.params)
  }, [route?.params])

  useEffect(() => {
    recaptcha.createVerifier()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const resendSmsCode = useCallback(async () => {
    SignInStore.signIn(recaptcha.verifier).catch((e) => console.log(e))
  }, [recaptcha.verifier])

  const signInVerifyPhone = useCallback(() => {
    if (otp.length === 6) {
      if (isNewUser) {
        newUserSignInVerify(otp)
          .then((res) => {
            const { user } = res || {}
            SignupStore.setUpAutoPhoneSignup(login, codeVerifier, user)
            if (dontNavigate) {
              dontNavigate(false)
              setGoToForm(true)
            } else {
              navigation.navigate(paths.Auth.SignUpForm)
            }
          })
          .catch(() => {})
      } else {
        SignInStore.signInVerifyPhone(otp)
          .then(() => {
            if (RootStore.routeParams.loanid) {
              navigation.navigate(paths.Console.Credit.LoanDetails, {
                id: RootStore.routeParams.loanid,
              })
            }
            if (RootStore.routeParams?.action === 'request-credit') {
              navigation.navigate(paths.Console._self, {
                screen: paths.Console.Credit._self,
              })
            }
            LocalStorage.get('screen').then((screen) => {
              if (screen) {
                LocalStorage.remove('screen')
                const action = dispatcher(
                  pathFactory(screen.screen),
                  screen.params,
                )
                navigation.replace(action.name, action.params)
              }
            })
            setTimeout(() => {
              SignInStore.setCodeVerifier(false)
            }, 3000)
          })
          .catch(() => {})
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation, otp, codeVerifier, newUserSignInVerify, isNewUser, login])
  useEffect(() => {
    if (otp.length === 6) {
      signInVerifyPhone()
    }
  }, [otp, signInVerifyPhone])
  const navigateBack = () => {
    SignInStore.setCodeVerifier(null)
    if (!dontNavigate) navigation.navigate(paths.Auth.SignIn)
  }
  useLayoutEffect(() => {
    if (!canAskOtp) {
      navigation.replace(paths.Auth.SignIn)
    }
  }, [canAskOtp, navigation])
  const { t } = useTranslation('auth')
  return (
    <Layout onBackPress={navigateBack}>
      <BackButton onPress={navigateBack} testID="back-button-to-login" />
      <Title testID="code-title">{t('codeTitle')}</Title>
      <Spacer height={16} />
      <SubTitle testID="code-subtitle">
        {t('codeSubTitle')}
        <Text style={{ color: commonColors.accentText }}>
          ****{login.slice(-4)}
        </Text>
      </SubTitle>
      <Spacer height={40} />
      <OtpInput
        otp={otp}
        onChange={(e) => {
          setOtp(e)
          errors.get('verify') && removeError('verify')
        }}
        testID="six-digit-code-component"
      />
      <Spacer />
      <ErrorMessage error={errors.get('verify')?.message} />
      <Spacer height={20} />
      <Text
        style={{
          fontSize: 14,
          color: commonColors.textLight,
          marginVertical: 20,
          textAlign: sm ? undefined : 'center',
        }}
        testID="codeQuestion"
      >
        {t('codeQuestion')}
        <Link
          title={t('resendCode')}
          color="#00A0F3"
          onPress={resendSmsCode}
          testID="resend-code-link"
        />
      </Text>
      <Observer>
        {() => (
          <SubmitButton
            disabled={isBusy || otp.length !== 6 || !!errors.get('verify')}
            onPress={signInVerifyPhone}
            loading={RootStore.isBusy}
          >
            {t('signIn.loginButtonLabel')}
          </SubmitButton>
        )}
      </Observer>
      <Text
        style={{
          color: commonColors.textLight,
          marginTop: 40,
          fontWeight: '500',
          fontSize: 16,
        }}
        testID="signup-question"
      >
        {t('signIn.signUpQuestion')}
        <Link
          textStyle={{ fontWeight: '500', fontSize: 16 }}
          title={t('SignUp')}
          color="#00A0F3"
          onPress={() =>
            dontNavigate
              ? dontNavigate(false)
              : navigation.replace(paths.Auth.SignUp)
          }
          testID="signup-link"
        />
      </Text>
      <Spacer />
    </Layout>
  )
})
